const errors = [{
        prefix: ['/products'],
        source: 'https://github.com/Wiredcraft/omni-pcm/blob/dev/server/constants/errors.js',
        errors: {
            1000: 'server internal error',
            2000: 'sold stock can not be negative',
            2001: 'available stock can not be negative',
            2002: 'stock input should be positive number',
            2012: 'invalid request body',
            2003: 'inventory not found',
            2103: 'record not found',
            2104: 'batch inventories update not allowed as order id record already existed',
            2105: 'batch inventories reset not allowed as order id record not existed',
            2004: 'too many inventory ids in one query',
            2005: 'the inventory has modified, retry again',
            2006: 'product(s) not found',
            2007: 'inventory counter not found',
            2008: 'cannot find schema id for inventory',
            2009: 'fail to validate inventory',
            2010: 'product type(s) not found',
            2011: 'inventory stock can not be less than sold',
            2015: 'invalid inventory',
            2013: 'product message not found',
            2014: 'product can have only one message',
            3000: 'productType id or inventorySchema id not match',
            3001: 'ui schema not valid',
            3002: 'invalid alias',
            4001: 'collection not found',
            4002: 'collection mapping exist',
        },
    }, {
        prefix: ['/orders'],
        source: 'https://github.com/Wiredcraft/omni-oms/blob/dev/oms-core/omni-oms-constants/lib/error-codes.js',
        errors: {
            1000: 'Response Parser: malformed response',
            1001: 'Bad schema',
            1002: 'Query view failed',
            1003: 'Create event failed',
            1004: 'Request too frequent',
            1005: 'Not support to fitler with triple state/userId/startdate',
            1006: 'Query interval is too large',
            1007: 'Query limit is too large',
            1100: 'Unified payment failed',
            1101: 'Payment info mismatch',
            1102: 'Payment refund failed',
            1103: 'Payment refund not allowed',
            1104: 'Payment query service unavailable',
            1105: 'Unable to create prepayment due to invalid order state or 0 payment or no payment provider info',
            1106: 'Fail to get prepay order string for ALIPAY',
            1107: 'Fail to close wepay/alipay order as being paid',
            1108: 'Fail to close alipay order due to internal error',
            1109: 'Fail to close wepay order due to internal errosr',
            1111: 'User has no default payment method',
            1200: 'Order create failed',
            1201: 'Order not found',
            1202: 'Order info mismatch',
            1203: 'Pending order left, not allow to create new order',
            1210: 'Update order status to paid failed',
            1211: 'Update order status to processed failed',
            1212: 'Update order status to shipped failed',
            1213: 'Update order status to Cancel failed',
            1214: 'Update order status to Completed failed',
            1215: 'Update order information failed',
            1216: 'Cancel order not allowed',
            1217: 'Unable to proceed as order is not yet paid',
            1218: 'Unable to proceed as order is free or payment already refunded',
            1219: 'Not allow to refund',
            1220: 'Unable to find history orders to preceed with refund',
            1221: 'Invalid order state machine transition',
            1222: 'not allow to create duplicated renewal order for same subscription id',
            1223: 'Unable to create order due to purchase limit',
            1300: 'Query user information failed',
            1301: 'Query product internal failure',
            1302: 'Update inventory failed',
            1303: 'Inventory not found',
            1304: 'Stock is not enough for decrease',
            1305: 'Create event tickets failed',
            1306: 'Inventory service internal failure',
            1307: 'Inventory batch reset failure',
            1308: 'Query product failure as bad input',
            1400: 'Query user service internal failure',
            1401: 'Query user information failed as bad input',
            1500: 'Loyalty service general internal failure',
            1501: 'Loyalty service error as bad input',
            1502: 'Loyalty has existing membership (409/12001)',
            1503: 'Loyalty Membership not found (404/12000)',
            1504: 'Can not cancel the membership, refund is not allowed (403/12003)',
            1505: 'Loyalty Illegal upgrade params (403/12003)',
            1506: 'Invalid membership effective time (403/12004)',
            1507: 'Loyalty Membership program not found (404/13000)',
            1508: 'Loyalty Invalid program (400/13001)',
            1509: 'Loyalty Subscription not found (404/10000)',
            1510: 'Loyalty PaymentMethod not found (404/14001)',
            1511: 'Loyalty Subscription existed (400/100001)',
            1512: 'Loyalty Subscription not active (403/10002))',
            1513: 'Loyalty Invalid membership (400/12005)',
            1514: 'Loyalty Expired membership (404/12006)',
            1515: 'Loyalty Invalid Payment method (400/14001)',
            1516: 'Loyalty Membership Cancel not allowed (403/12011)',
            1517: 'Loyalty Membership Upgrade not allowed (403/12012)',
            1518: 'Loyalty Coupon not found (404/15003)',
            1519: 'Loyalty Invalid Coupon (400/15004)',
            2000: 'General stripe error',
            2001: 'StripeCardError',
            2002: 'StripeInvalidRequestError',
            2003: 'StripeAPIError',
            2004: 'StripeConnectionError',
            2005: 'StripeAuthenticationError',
            2006: 'StripeRateLimitError',
            2007: 'StripePermissionError',
            2008: 'StripeIdempotencyError',
            2009: 'StripeInvalidGrantError',
            3000: 'General Paymentus API error',
            3001: 'Paymentus payment error due to bad input',
            3002: 'Paymentus payment not accepted',
            3003: 'paymentus refund parameter error',
            3004: 'paymentus refund not accepted',
            3005: 'paymentus payment token not belong to current user profile',
            3006: 'paymentus payment rejected as duplication, but no transaction was found',
        },
    }, {
        prefix: ['/payments', '/memberships', '/coupons', '/subscriptions', '/subscription'],
        source: 'https://github.com/Wiredcraft/omni-loyalty/blob/dev/server/constants/errors.js',
        errors: {
            10000: 'Not implement',
            10001: 'Server error',
            10002: 'Illegal user',
            10003: 'NSQ error',
            10004: 'Invalid job type',
            10005: 'missing required parameters',
            10006: 'customer data incomplete',
            11000: 'Subscription not found',
            110001: 'Subscription existed',
            11002: 'Subscription not active',
            11003: 'Invalid subscription',
            11004: 'Subscription upgrade to Vip is not allowed',
            11005: 'Membership filter only supports active status',
            12000: 'Membership not found',
            12001: 'User already has a membership',
            12002: 'Can not cancel the membership, refund is not allowed.',
            12003: 'Illegal upgrade params',
            12004: 'Invalid membership effective time',
            12005: 'Invalid membership',
            12006: 'Expired membership',
            12007: 'Membership renewal is not allowed',
            12008: 'Multiple active Memberships',
            12009: 'Query interval is too large',
            12010: 'Query limit is too large',
            12011: 'Cancel is not allowed, membership is about to expire in a few minutes',
            12012: 'Upgrade is not allowed, membership is about to expire in a few minutes',
            12013: 'Subscription Change is not allowed, membership is about to expire in a few minutes',
            13000: 'Membership inventory not found',
            13001: 'Invalid upgrade',
            14000: 'PaymentMethod not found',
            14001: 'Invalid Payment method',
            14002: 'Stripe server error',
            14003: 'We are unable to accept pre-paid cards at this time. Please enter valid credit card information to continue.',
            15000: 'Coupon code exists',
            15001: 'Inventory is not for VIP',
            15002: 'Coupon inventory not found',
            15003: 'Coupon not found',
            15004: 'Invalid coupon',
            15005: 'Expired coupon',
            15006: 'No Coupon inventory set',
        },
    }, {
        prefix: ['/api/contact/external/users/', '/api/internal/users'],
        source: 'https://github.com/Wiredcraft/omni-contact/blob/custom-hagerty/server/constants/errors.js',
        errors: {
            1000: 'malformed response',
            1001: 'Bad schema',
            1002: 'Query view failed',
            1100: 'Auth issuer not found',
            1101: 'User info mismatch',
            1102: 'Asset not found',
            1103: 'User not found',
            1104: 'Sync failed, please retry',
            1105: 'Update "birthdate" not allowed',
            1107: 'Schema validation failed',
            1200: 'Request OIDC user profile failed',
            1201: 'Request Salesforce user profile failed',
            1202: 'Failed to fetch user profile , too many requests',
            1203: 'Account PersonEmail is missing in Salesforce',
            1204: 'salesforce federation id not matching with oidc',
        },
    },
];
const getUserFriendlyErrorMessage = (code, endpoint) => {
    const m = errors.find(module => (module.prefix.some(prefix => endpoint.includes(prefix))));
    if (!(m === null || m === void 0 ? void 0 : m.errors[code])) {
        console.log('getBackendErrorMessage:', code, endpoint, m === null || m === void 0 ? void 0 : m.errors[code]);
    }
    return m === null || m === void 0 ? void 0 : m.errors[code];
};
export default getUserFriendlyErrorMessage;
